require('./index.scss')
import Tooltip from '@/components/Tooltip'
import Icon from '@/components/Tooltip/Icon'
import Total from '@/components/Total'
import QuantityWithOptions from
    "@/components/VariantSelectorContainer/QuantityWithOptions"
import variantSelectorContainerShape
  from '@/propTypeShapes/variantSelectorContainer'

import CarbonNeutralityDialog from '../CarbonNeutralityDialog'
import BulkStorePurchaseOptionsLink from './BulkStorePurchaseOptionsLink'
import Expiration from './Expiration'
import GiftModal from './GiftModal'
import PayPalBNPL from './PayPalBNPL'
import Savings from './Savings'
import Title from './Title'
import VariantActions from './VariantActions'
import Variants from './Variants'

const VariantSelectorContainer = ({
  bulkStorePurchaseOptionsLinkProps,
  canShowGiftLink,
  canShowCarbonNeutrality,
  currency,
  isbn,
  isPackage,
  isBulkIntegrationEnabled,
  isVirtualStore,
  isPayPalBNPLEnabled,
  isPrint,
  isShowingExpiration,
  isShowingSavings,
  isZeroDecimalCurrency,
  taxes,
  titleProps,
  total,
  translations,
  variantsProps
}) => {
  return (
    <div>
      <div className='variant-selector-container selector card'>
        <div className='variant-selector-wrap'>
          <fieldset>
            <div className='isbn'>
              <If condition={isbn}>
                <h2 aria-hidden="true">
                  <span className='isbn-label'>
                    {`${translations.isbn_label}:`}
                  </span>
                  <span className='isbn-value'>
                    {isbn}
                    {isPrint
                      ? (<link href="http://schema.org/Paperback" />)
                      : (<link href="http://schema.org/EBook" />)
                    }
                  </span>
                  <If condition={isPackage}>
                    <Tooltip
                      tooltipContentId="package-tooltip"
                      tooltipText={translations?.tooltips_package}
                    >
                      <Icon styles="line-height-3" />
                    </Tooltip>
                  </If>
                </h2>
              </If>
            </div>
            <div className='variants-wrapper'>
              <Variants {...{
                currency,
                isZeroDecimalCurrency,
                taxes,
                translations,
                variantsProps,
              }}
              />
            </div>
          </fieldset>
        </div>
        <div className='expiration-and-total-wrap'>
          <Title {...{ ...titleProps }} />
          <Total {...{
            currency,
            isZeroDecimalCurrency,
            taxes,
            total
          }}
          />
          {!isPrint && <Expiration isShowingExpiration={isShowingExpiration} />}
          <Savings {...{ isShowingSavings }} />
          <If condition={isBulkIntegrationEnabled || isVirtualStore}>
            <QuantityWithOptions {...{ translations }} />
          </If>
          <VariantActions translations={translations} />
          <If
            condition={
              canShowGiftLink
              && !isBulkIntegrationEnabled && !isVirtualStore
            }
          >
            <GiftModal />
          </If>
          <PayPalBNPL {...{ isPayPalBNPLEnabled, total }} />
          <BulkStorePurchaseOptionsLink
            {...{ ...bulkStorePurchaseOptionsLinkProps }}
          />
          <If condition={canShowCarbonNeutrality}>
            <CarbonNeutralityDialog />
          </If>
        </div>
      </div>

    </div>
  )
}

export default VariantSelectorContainer

VariantSelectorContainer.propTypes = variantSelectorContainerShape
